import { jwtDecode } from "jwt-decode";

type Listener = (token: string | null) => void;

// The access token lives only in this module's memory. It must never be written to
// localStorage, sessionStorage or IndexedDB (see constitution Principle VI).
let accessToken: string | null = null;
let expiresAt: number | null = null;
const listeners = new Set<Listener>();

const decodeExpiry = (token: string): number | null => {
  try {
    return jwtDecode(token).exp ?? null;
  } catch {
    return null;
  }
};

export const getAccessToken = () => accessToken;

// Epoch seconds from the token's `exp` claim, or null when unknown.
export const getAccessTokenExpiry = () => expiresAt;

export const setAccessToken = (token: string | null) => {
  if (!token) {
    clearAccessToken();
    return;
  }
  accessToken = token;
  expiresAt = decodeExpiry(token);
  listeners.forEach(listener => listener(accessToken));
};

export const clearAccessToken = () => {
  if (accessToken === null) return;
  accessToken = null;
  expiresAt = null;
  listeners.forEach(listener => listener(null));
};

export const subscribeAccessToken = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
